import axios from 'axios'
import Cookies from 'js-cookie'

import Crypto from '@/plugins/crypto'

import API from '@/api'

import User from '@/models/user'

const state = {
    apiToken: null,
    user: null
}

const getters = {

  apiToken: state => state.apiToken,

  isLogged: state => !!state.user,

  user: state => state.user,

}

const actions = {

  checkLocalUserData({ commit })
  {
    const userData = localStorage.getItem('user')
    
    if (userData)
    {
      let decrypted = Crypto.decrypt(userData)
      
      commit('setUserData', decrypted)
    }
  },

  login ({ commit }, credentials)
  {
    return API.auth.login(credentials)
      .then(({ data }) => {
        commit('setUserData', data)
      })
  },

  logout ({ commit })
  {
    commit('clearUserData')
  },

  refreshUserData({ commit })
  {
    return API.auth.user({ include:'groups' })
      .then(({ data }) => {
        commit('setUserData', data)
      })
      .catch((err)=>{
        console.log(err)
      })
  },

}

const mutations = {

    setUserData (state, userData)
    {
      state.user = new User(userData.user)

      state.apiToken = userData.token

      let json = JSON.stringify(userData),
          encrypted = Crypto.encrypt(json)
      
      localStorage.setItem('user', encrypted)

      axios.defaults.headers.common.Authorization = `Bearer ${userData.token}`
    },

    clearUserData (state)
    {
      state.user = null

      state.apiToken = null

      localStorage.removeItem('user')
      
      Cookies.remove('XSRF-TOKEN')
      
      location.reload()
    },

}

const auth = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default auth